import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: { xs: '12px', md: '16px' },
    width: '100%',
    padding: { xs: '12px', md: '24px' },
    borderRadius: '16px',
    border: '1px solid',
    borderColor: 'border.light',
    backgroundColor: 'background.paper',
    boxShadow: 'none',
    textDecoration: 'none',
    color: 'inherit',
    boxSizing: 'border-box',
    '&:hover': {
      boxShadow: '0px 8px 28px rgba(0, 0, 0, 0.12)',
    },
  },
  image: {
    flexShrink: 0,
    width: { xs: '88px', md: '142px' },
    height: { xs: '72px', md: '92px' },
    borderRadius: '12px',
    overflow: 'hidden',
    '& img': {
      objectFit: 'cover',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '8px', md: '12px' },
    minWidth: 0,
    flex: 1,
  },
  title: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    textOverflow: 'ellipsis',
  },
  meta: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '6px 8px',
    minWidth: 0,
  },
  author: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    textDecoration: 'underline',
    color: 'text.primary',
    minWidth: 0,
  },
  avatar: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    flexShrink: 0,
    overflow: 'hidden',
    '& img': {
      objectFit: 'cover',
    },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
